import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<HeadLayout />\n<Header />\n<Header::SecondaryNav />\n{{outlet}}\n<Footer />",{ moduleName: "tpk-website/templates/application.hbs" })